export const COMETCHAT_CONSTANTS = {
  APP_ID: "2772545df97b8753",
  REGION: "us",
  AUTH_KEY: "d45265a1f91c427adf38049e3e348460bd0beff5",
};
